import { Button, Container, Notice, Separator, Text } from '@teliaee/design-system';
import { observer } from 'mobx-react';
import * as React from 'react';
import { ACCOUNT } from '../Routes';
import useStores from '../stores/UseStores';

interface AddEmailSuccessNoticeProps {
  email: string;
}

const AddEmailSuccessNotice = observer((props: AddEmailSuccessNoticeProps): React.JSX.Element => {
  const { email } = props;
  const {
    translateStore: { translate },
    routeStore,
  } = useStores();

  return (
    <Container>
      <Text>
        <Notice>{translate('add_email_success.header', { email })}</Notice>
        <Separator color="invisible" spacing="small" />
        <Text className="text-center">
          <Button
            onClick={routeStore.navigate}
            url={`${ACCOUNT}${routeStore.formForwardParams}`}
            text={translate('add_email_success.button')}
            iconRight="#arrow-right"
          />
        </Text>
      </Text>
    </Container>
  );
});

export default AddEmailSuccessNotice;
